import { Theme } from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import * as React from 'react';
import S from './ResourceCard.styles';
import { getSystemIcon, SystemIcon } from '@helpers/icons';
import { FocusRing } from 'react-aria';
import { getSrcs } from '@helpers/image';
const ResourceCard = (props) => {
    const imageSrc = getSrcs(props.image, 492, 310, 4);
    return (React.createElement(S.Container, { "data-background": props.theme ?? Theme.Teal },
        React.createElement(S.ImageContainer, null,
            React.createElement(S.LinkArea, { href: props.cta.url, target: props.cta.target ?? '_self' },
                React.createElement(S.TagsContainer, null, props.tags.map((tag, i) => (React.createElement(S.Tag, { key: `tag-${i}`, "data-tag-theme": tag.theme },
                    React.createElement(S.TagTitle, null, tag.title))))),
                React.createElement(S.ImageWrapper, null,
                    React.createElement(S.Image, { src: imageSrc.src, srcSet: imageSrc.srcSet, alt: props.image.altText, role: props.image.altText ? 'img' : 'presentation', loading: 'lazy' })),
                props.collectionTag && React.createElement(S.CollectionTag, null, props.collectionTag)),
            React.createElement(S.ButtonArea, null,
                React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                    React.createElement(S.ViewResourceButton, { href: props.cta.url, target: props.cta.target ?? '_self' },
                        React.createElement(S.EyeClose, null, getSystemIcon(SystemIcon.EyeClosed)),
                        React.createElement(S.EyeOpen, null, getSystemIcon(SystemIcon.EyeOpen)))),
                React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                    React.createElement(S.DownloadResourceButton, { href: props.downloadCta.url, target: props.downloadCta.target }, getSystemIcon(SystemIcon.Download))))),
        React.createElement(S.ContentContainer, null,
            React.createElement(S.TitleArea, null,
                React.createElement(S.Title, null,
                    React.createElement(S.CardLink, { href: props.cta.url, target: props.cta.target ?? '_self' }, props.title)),
                React.createElement(S.AgeTag, { "data-tag-theme": props.ageTag.theme }, props.ageTag.title)),
            props.introduction && React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: props.introduction } }),
            React.createElement(S.HashTagArea, null, props.hashTags.map((hashTag, i) => (React.createElement(S.HashTag, { key: `hashTag-${i}` },
                "#",
                hashTag)))))));
};
export default ResourceCard;
